import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=5d19bcc2&scoped=true&"
import script from "./SingleFileUpload.vue?vue&type=script&lang=ts&"
export * from "./SingleFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SingleFileUpload.vue?vue&type=style&index=0&id=5d19bcc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19bcc2",
  null
  
)

export default component.exports